import { FileEntity } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formId: number;
  fileEntities: FileEntity[];
}

export const modifyCustomFormFieldsFilesRequest = ({
                                                     token,
                                                     formId,
                                                     fileEntities,
                                                   }: RequestParams): Promise<void> => {
  return ApiServiceInstance.makeRequest(`/custom-form/${ formId }/file-fields`, {
    method: 'PUT',
    token,
    body: fileEntities,
  });
};